import { PickSessionSchema } from "@redotech/redo-model/wms/schema/pick-session";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const skipPickSessionItem = {
  name: "skipPickSessionItem" as const,
  input: z.object({
    pickSessionId: zExt.objectId(),
    itemIds: z.array(zExt.objectId()),
  }),
  output: z.object({
    success: z.boolean(),
    updatedPickSession: PickSessionSchema.nullish(),
  }),
};
